import type { ObjId } from '../../components/Obj.tsx'

/** Answers of "Rencana" (docs/PRD.md US-2.4). Keys mirror PLAN_BERJUANG / PLAN_JADI in @iqrapath/shared. */
export const BERJUANG: { key: string; label: string; obj: ObjId }[] = [
  { key: 'amarah', label: 'Menahan amarah', obj: 'rasa-kesal' },
  { key: 'hp', label: 'Lepas dari HP', obj: 'hp' },
  { key: 'shalat', label: 'Menjaga shalat', obj: 'sajadah' },
  { key: 'uang', label: 'Urusan uang', obj: 'dompet' },
  { key: 'anak', label: 'Mendidik anak', obj: 'anak-kereta' },
  { key: 'cemas', label: 'Rasa cemas', obj: 'rasa-cemas' },
  { key: 'baca', label: 'Rutin baca Qur’an', obj: 'mushaf' },
]

export const JADI: { key: string; label: string; obj: ObjId }[] = [
  { key: 'tenang', label: 'Lebih tenang', obj: 'bulan' },
  { key: 'sabar', label: 'Lebih sabar', obj: 'jam-pasir' },
  { key: 'syukur', label: 'Lebih bersyukur', obj: 'rasa-syukur' },
  { key: 'dekat', label: 'Lebih dekat dengan Allah', obj: 'lampu' },
  { key: 'bermanfaat', label: 'Lebih bermanfaat untuk orang lain', obj: 'teko' },
]

export const MENIT = [5, 10, 20] as const
